import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import {
    RemoveCartLineApiParameter,
    removeCartLineWithResult as removeCartLineApi,
} from "@insite/client-framework/Services/CartService";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartLineIds: string | string[]; // Accept single or multiple cartLineIds
        cartId: string;
    } & HasOnSuccess,
    RemoveCartLineApiParameter
>;

export const DispatchBeginRemoveCartLine: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
    const cartLineIds = Array.isArray(props.parameter.cartLineIds)
        ? props.parameter.cartLineIds
        : [props.parameter.cartLineIds];
    cartLineIds.forEach(cartLineId =>
        props.dispatch({
            type: "Pages/Cart/BeginRemoveCartLine",
            cartLineId,
        }),
    );
};

export const RemoveCartLine: HandlerType = async props => {
    const cartLineIds = Array.isArray(props.parameter.cartLineIds)
        ? props.parameter.cartLineIds
        : [props.parameter.cartLineIds];

    for (const cartLineId of cartLineIds) {
        const apiParameter: RemoveCartLineApiParameter = {
            cartLineId,
            cartId: props.parameter.cartId,
        };
        await removeCartLineApi(apiParameter);
    }
};

export const LoadCart: HandlerType = props => {
    const cartId = props.parameter.cartId;
    props.dispatch(
        loadCart({
            apiParameter: {
                cartId,
                expand: ["cartLines", "hiddenproducts", "restrictions"],
            },
        }),
    );
};

/** @deprecated Not needed anymore */
export const LoadPromotions: HandlerType = () => {};

export const DispatchCompleteRemoveCartLine: HandlerType = props => {
    const cartLineIds = Array.isArray(props.parameter.cartLineIds)
        ? props.parameter.cartLineIds
        : [props.parameter.cartLineIds];
    cartLineIds.forEach(cartLineId =>
        props.dispatch({
            type: "Pages/Cart/CompleteRemoveCartLine",
            cartLineId,
        }),
    );

    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
    props.dispatch({
        type: "Data/OrderApprovals/Reset",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginRemoveCartLine,
    RemoveCartLine,
    LoadCart,
    LoadPromotions,
    DispatchCompleteRemoveCartLine,
    ExecuteOnSuccessCallback,
];

const removeSavedOrderCartLine = createHandlerChainRunner(chain, "RemoveSavedOrderCartLine");
export default removeSavedOrderCartLine;
